import { UserProfile } from '@chr/online-shared-microsite-core';
import { ActionTypes, FeatureFlags, IFeatureFlagsAction } from './constants';

// Action Creators
export function getFeatureFlags(userProfile: UserProfile): IFeatureFlagsAction {
  return {
    type: ActionTypes.FEATURE_FLAGS_INIT,
    payload: userProfile,
  };
}

export function setFeatureFlags(featureFlags: FeatureFlags): IFeatureFlagsAction {
  return {
    type: ActionTypes.FEATURE_FLAGS_SET,
    payload: featureFlags,
  };
}

export function featureFlagsRetrievalFailed(): IFeatureFlagsAction {
  return {
    type: ActionTypes.FEATURE_FLAGS_RETRIEVAL_FAILED,
  };
}
